import React from 'react';
import clsx from 'clsx';

interface RoddoPageShellProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  padding?: 'none' | 'sm' | 'md';
  /** Let App.tsx's existing content scroller own vertical scrolling. */
  allowParentScroll?: boolean;
  /** Remove generic page gutters/max-width for workspace-style screens. */
  fullBleed?: boolean;
}

const paddingMap: Record<NonNullable<RoddoPageShellProps['padding']>, string> = {
  none: 'px-0 pt-0 pb-0',
  sm: 'px-3 pt-3 pb-0 min-[390px]:px-4 sm:px-5 lg:px-6 lg:pt-5',
  md: 'px-3.5 pt-4 pb-0 min-[390px]:px-5 sm:px-6 lg:px-8 lg:pt-6',
};

const RoddoPageShell: React.FC<RoddoPageShellProps> = ({
  children,
  className,
  contentClassName,
  padding = 'sm',
  allowParentScroll = false,
  fullBleed = false,
}) => {
  return (
    <div
      data-roddo-shell="page"
      className={clsx(
        'roddo-final-shell roddo-page-shell relative min-h-full min-w-0 w-full bg-transparent',
        allowParentScroll ? 'overflow-visible' : 'overflow-hidden',
        fullBleed ? paddingMap.none : paddingMap[padding],
        className,
      )}
    >
      <div className="roddo-vibe-layer opacity-10 dark:opacity-[0.035]" />
      
      
      <div
        className={clsx(
          'relative z-10 flex min-w-0 w-full flex-col gap-3.5 sm:gap-4',
          fullBleed ? 'max-w-none' : 'mx-auto max-w-4xl lg:max-w-6xl',
          !allowParentScroll && 'roddo-content-scroll',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default RoddoPageShell;
